<ws-modal-wrapper headerLabel="Reports Sites"
                  cancelLabel="Close"
                  [hideSave]="true"
                  [excludeModalStyling]="true"
                  (cancel)="cancel()">
    <div class="ws-flex-container-vertical ws-flex-auto ws-stretch">
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    </div>
</ws-modal-wrapper>
